import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.66683 4H16.3335M10.5002 4V9M10.5002 17.3333V12.3333M7.16683 8.16667C5.89589 8.41432 4.90258 8.79659 4.34097 9.25419C3.77936 9.71179 3.68083 10.2191 4.06066 10.6976C4.44049 11.176 5.27746 11.5987 6.44176 11.9003C7.60605 12.2018 9.0326 12.3652 10.5002 12.3652C11.9677 12.3652 13.3943 12.2018 14.5586 11.9003C15.7229 11.5987 16.5598 11.176 16.9397 10.6976C17.3195 10.2191 17.221 9.71179 16.6594 9.25419C16.0978 8.79659 15.1044 8.41432 13.8335 8.16667",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }